import format from "date-fns/format";

export default date => {
  return format(new Date(date), "MMM d, yyyy @ HH:mm:ss");
};
